import _ from "lodash"
import { API } from "../service/proApi"

{
  // const DevisDatas = [
  //   {
  //     type: "devis",
  //     reference: "DEV-2017-0001",
  //     name: "Mitchell Poole",
  //     adress: "14 Grady Haven Apt. 262",
  //     price: 3728,
  //     date: "07/15/2018"
  //   },
  //   {
  //     type: "facture",
  //     reference: "DEV-2017-0002",
  //     name: "Jean Reese",
  //     adress: "67 Laury flat",
  //     price: 434,
  //     date: "07/28/2018",
  //     statut: 1
  //   },
  //   {
  //     type: "devis",
  //     reference: "DEV-2017-0044",
  //     name: "Bradley Mason",
  //     adress: "14 liza Burg Suite 793",
  //     price: 1234,
  //     date: "11/20/2018",
  //     statut: 2
  //   },
  //   {
  //     type: "devis",
  //     reference: "DEV-2017-0123",
  //     name: "Leo Morrison",
  //     adress: "796 Bayer Mill Suite 127",
  //     price: 763,
  //     date: "04/21/2018",
  //     statut: 3
  //   },
  //   {
  //     type: "facture",
  //     reference: "DEV-2017-0004",
  //     name: "Angel Haynes",
  //     adress: "7728 Trenton Viaduct Apt. 783",
  //     price: 983,
  //     date: "01/08/2018",
  //     statut: 2
  //   },
  //   {
  //     type: "devis",
  //     reference: "DEV-2017-9833",
  //     name: "Ella Rowe",
  //     adress: "10 Emmett Causeway Apt.656",
  //     price: 443,
  //     date: "04/01/2018",
  //     statut: 1
  //   },
  //   {
  //     type: "facture",
  //     reference: "DEV-2017-1265",
  //     name: "Russell Matthews",
  //     adress: "6834 Braun Ford",
  //     price: 673,
  //     date: "05/24/2018",
  //     statut: 0
  //   },
  //   {
  //     type: "devis",
  //     reference: "DEV-2017-0019",
  //     name: "Dorothy Walters",
  //     adress: "2743 Eloy Lights Apt. 669",
  //     price: 243,
  //     date: "10/28/2018",
  //     statut: 2
  //   }
  // ]
}

const getAllFactures = function(token) {
  return new Promise((resolve, reject) => {
    API.getAllFactures(token).then(res => {
      var data = res.data
      console.log("GET facture :", data.invocies)
      if (data.code === 404) {
        // No refmoe found
        resolve([])
      }
      resolve(
        _.map(data.invocies, x => {
          console.log("???? :", data)
          return {
            ...x,

            type: "devis",
            reference: x.label,
            name: x.fkuiduser,
            adress: x.adress,
            price: 243,
            date: "10/28/2018",
            statut: 2

            // name: data.invocies[2].label,
            // nameClient: data.invocies[2].

            //type: "workforce"
          }
        })
      )
    })
  })
}

// Data
const fetchData = function(token) {
  var facturesPromise = getAllFactures(token)
  return new Promise((resolve, reject) => {
    Promise.all([facturesPromise]).then(responses => {
      console.log("ALL RESPONSES HIHIHI", responses)
      resolve([...responses[0]]) // TODO Replace by API call
    })
  })
}

// Create
const createInvoices = function(token, invoiceData) {
  return new Promise((resolve, reject) => {
    API.createInvoice(token, invoiceData)
      .then(res => {
        var data = res.data
        console.log("CREATE Invoice :", data)
        if (data.code === 201) {
          reject(data.msg)
        }
        resolve(data)
      })
      .catch(() => {
        reject(`J'ai tout foiré`)
      })
  })
}

const getDisplayedData = (dataList, filters, searchValue, tabVal) => {
  console.log("Displaying data with filter : ", tabVal)

  return _.filter(
    dataList,
    x =>
      filters.indexOf(x.type) > -1 &&
      filter(x, searchValue) &&
      (!tabVal || tabVal.length == 0 || tabVal.indexOf(x.statut) > -1)
  )
}

//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::://
//                               DEVIS FACTURES SERVICE                             //
//                                  LOGIC SEARCH BAR                                //
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::://
const filter = function(entry, searchValue) {
  var entryName = (entry || {}).name
  var shouldFilter = (searchValue || "").length > 0
  return shouldFilter
    ? (entryName || "").toLowerCase().indexOf(searchValue.toLowerCase()) > -1
      ? entry
      : undefined
    : entry
}

export default {
  fetchData: fetchData,
  createInvoices,
  getDisplayedData,
  getAllFactures
}



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/DevisFactureService.js